export default __webpack_public_path__ + "static/media/amertrad5.9ecfd47a.png";